import { StickerCard } from "@/components/sticker-card/StickerCard.tsx";
import { Button, FullScreenPage, Stack, Text, Title } from "@skailer-com/uikit";
import { useTranslation } from "react-i18next";

export interface EsignSuccessScreenProps {
  documentTitle: string;
  fileName: string;
  signerCount: number;
  onDone: () => void;
  onRequest: () => void;
}

export function EsignSuccessScreen({
  documentTitle,
  fileName,
  signerCount,
  onDone,
  onRequest,
}: EsignSuccessScreenProps) {
  const { t } = useTranslation();

  return (
    <FullScreenPage
      isCenterVertical={true}
      contentSize={"lg"}
      actionsSlot={
        <Stack direction={"horizontal"} gap={"sm"}>
          <Button variant={"secondary"} size={"lg"} onClick={onRequest}>
            {t("core:esign_request_now")}
          </Button>
          <Button variant={"primary"} size={"lg"} onClick={onDone}>
            {t("common:done")}
          </Button>
        </Stack>
      }
    >
      <Stack direction={"horizontal"} items={"center"}>
        <StickerCard
          title={documentTitle}
          emoji={":writing_hand:"}
          contentSlot={
            <>
              <Text className={"text-secondary"}>
                {t("plurals:signers_count", { count: signerCount })}
              </Text>
              <Text className={"text-secondary"}>{fileName}</Text>
            </>
          }
        />
        <Stack className={"pl-18 pr-1"} gap={"lg"}>
          <Title
            size={"lg"}
            header={t("core:esign_ready_to_sign_title")}
            caption={t("core:esign_ready_to_sign_description")}
          />
          <Stack direction={"horizontal"} gap={"sm"}>
            <Button size={"lg"} variant={"primary"} onClick={onDone}>
              {t("common:done")}
            </Button>
            <Button size={"lg"} variant={"secondary"} onClick={onRequest}>
              {t("core:esign_request_now")}
            </Button>
          </Stack>
        </Stack>
      </Stack>
    </FullScreenPage>
  );
}
